import * as CollectionExpression from "./podtemat5_e8_zamkniete_types/E8CollectionExpressionClosedTask";
import * as CatDiscountExpression from "./podtemat5_e8_zamkniete_types/E8CatDiscountExpressionClosedTask";
import * as PerimeterFormula from "../temat6_wzory_i_zaleznosci/podtemat2_przeksztalcanie_wzorow_types/E8PerimeterFormulaTransformClosedTask";
import * as SumFormula from "../temat6_wzory_i_zaleznosci/podtemat2_przeksztalcanie_wzorow_types/E8SumFormulaClosedTask";
import * as SpeedTime from "../temat6_wzory_i_zaleznosci/podtemat3_predkosc_droga_czas_types/E8SpeedTimeClosedTask";
import * as BasketApples from "../temat4_uklady/podtemat2_zadania_tekstowe_types/E8BasketApplesClosedTask";

export const registry = {
  E8PerimeterFormulaTransformClosedTask: PerimeterFormula,
  E8CollectionExpressionClosedTask: CollectionExpression,
  E8CatDiscountExpressionClosedTask: CatDiscountExpression,
  E8SumFormulaClosedTask: SumFormula,
  E8BasketApplesClosedTask: BasketApples,
  E8SpeedTimeClosedTask: SpeedTime,
};

export function generateTasks(options = {}) {
  return [
    PerimeterFormula.generateTask(options),
    CollectionExpression.generateTask(options),
    CatDiscountExpression.generateTask(options),
    SumFormula.generateTask(options),
    BasketApples.generateTask(options),
    SpeedTime.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 algebra task type: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
